const CheckIcon = () => (
    <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.4933 9.93502C21.8053 10.2074 21.8374 10.6812 21.565 10.9933L13.7079 19.9933C13.5654 20.1564 13.3594 20.25 13.1429 20.25C12.9263 20.25 12.7203 20.1564 12.5779 19.9933L9.43502 16.3933C9.16261 16.0812 9.19473 15.6074 9.50677 15.335C9.8188 15.0626 10.2926 15.0947 10.565 15.4068L13.1429 18.3596L20.435 10.0068C20.7074 9.69473 21.1812 9.66261 21.4933 9.93502Z"
            fill="#2DC6FF"
        />
    </svg>
);

export default CheckIcon;
